import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { flowCapabilitiesResponseSchema, type FlowCapabilities } from './types';

interface Options {
  /** Empresa activa: entra al queryKey para no servir capacidades cacheadas de otra empresa. */
  companyId: string | null;
  /** No dispara hasta conocer la empresa activa (garantiza X-Active-Company en carga fría). */
  enabled: boolean;
}

/** Estado del flujo del documento + acciones disponibles. Valida el contrato con Zod:
 *  un drift del backend cae al estado de error de la query, nunca a pantalla blanca. */
export function useFlowCapabilities(
  id: string,
  { companyId, enabled }: Options,
): UseQueryResult<FlowCapabilities> {
  const api = useApi();
  return useQuery({
    queryKey: ['flow-capabilities', companyId, id],
    queryFn: async () => {
      const raw = await api.get<unknown>(`/api/v1/quality/documents/${id}/flow`);
      return flowCapabilitiesResponseSchema.parse(raw).data;
    },
    enabled,
  });
}
